module.exports = __webpack_public_path__ + "img/935.0c993687.png";